



















import {Component, Prop} from 'vue-property-decorator'
import {mixins} from "vue-class-component";
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";

@Component({})
export default class PromenaLozinke extends mixins(ComponentBaseMixin) {
  newPassword = '';
  repeatedPassword = '';
  error = false;
  @Prop() userId;

  async created() {

  }

  async promeniLozinku(bvModalEvent) {
    this.error = false;
    if (this.newPassword != this.repeatedPassword) {
      bvModalEvent.preventDefault();
      return;
    }

    try {
      await this.$http.post('/api/ChangePassword', {userId: this.userId, password: this.newPassword});
      this.showInfo("Lozinka je uspešno promenjena");
    } catch (e) {
      this.error = true;
      bvModalEvent.preventDefault();
    }
  }

  onClosed() {
    this.$emit('closed');
  }
}
